import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ATbutton from '@at.govt.nz/buttons';
import { fetchRoutesByStopId } from '../../../services/GtfsService';
import SortRouteShortNames from '../../../transforms/SortRouteShortNames';

import Shapes from '../../../utils/ShapeOfTypes';

const renderSpinner = () => (
  <div className="loading-wrapper">
    <div className="loading-spinner-small" />
  </div>
);
const renderRoutes = routes => (
  <div className="routes-container">
    <span id="stop_routes" className="routes">
      {`Routes: ${routes}`}
    </span>
  </div>
);
const getShortName = route => route.route_short_name;

export default class StopPopupDetail extends Component {
  constructor() {
    super();
    this.state = {
      stopRoutes: '',
    };

    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    const { stop, enableAccessibilityOutlines } = this.props;
    const { stopRoutes } = this.state;
    if (!stopRoutes[stop.stop_id]) {
      this._loadRoute(stop);
    }

    // eslint-disable-next-line no-unused-expressions
    this.buttonRef.current?.focus();
    enableAccessibilityOutlines();
  }

  _loadRoute = (stop) => {
    fetchRoutesByStopId(stop.stop_id).then(
      (routeList) => {
        const sortedList = SortRouteShortNames(_.uniq(_.map(routeList, getShortName)));
        this.setState(() => ({
          stopRoutes: sortedList.length ? _.join(sortedList, ', ') : '-',
        }));
      },
    ).catch(() => {
      this.setState(() => ({
        stopRoutes: '-',
      }));
    });
  }

  render() {
    const { onSelect, stop } = this.props;
    const { stopRoutes } = this.state;
    const title = `Stop ${stop.stop_code}`;
    return (
      <div className="stop-detail">
        <p className="title">
          {title}
        </p>
        <p className="description">
          {stop.stop_name}
        </p>
        <hr />
        { _.isEmpty(stopRoutes) ? renderSpinner() : renderRoutes(stopRoutes)}
        <div className="button-wrapper">
          <ATbutton className="button" block onClick={onSelect} aria-label="Schedules and tracking" ref={this.buttonRef}>
            Schedules & tracking
          </ATbutton>
        </div>
      </div>
    );
  }
}
StopPopupDetail.propTypes = {
  enableAccessibilityOutlines: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  stop: Shapes.Stop.isRequired,
};
